/**
 * Converts a React Element into an HTML decoded string. Implementation
 * uses a textarea to circumvent XSS risks that can arise with
 * dangerouslySetInnerHTML.
 *
 * @param {React.Symbol} symbol - The React Element to HTML decode
 */
const fromReactElementToString = symbol => {
  if (symbol?.type === 'a') {
    // If its a symbol and its an anchor tag, leave it alone.
    // This affects anchors that are format web-url.
    return symbol;
  }

  const value = symbol?.props?.children;
  if (!value) {
    return symbol;
  }
  // NOTE using textarea so we're protected from XSS and only
  // HTML entities are decoded.
  const decoded = document.createElement('textarea');
  decoded.innerHTML = value;
  return decoded.value;
};

export default fromReactElementToString;
